var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 1.89111V5.33323C11.6668 5.79994 11.6668 6.0333 11.7577 6.21156C11.8376 6.36836 11.965 6.49584 12.1218 6.57574C12.3001 6.66656 12.5335 6.66656 13.0002 6.66656H16.4423M11.6668 14.1665H6.66683M13.3335 10.8332H6.66683M16.6668 8.32336V14.3332C16.6668 15.7333 16.6668 16.4334 16.3943 16.9681C16.1547 17.4386 15.7722 17.821 15.3018 18.0607C14.767 18.3332 14.067 18.3332 12.6668 18.3332H7.3335C5.93336 18.3332 5.2333 18.3332 4.69852 18.0607C4.22811 17.821 3.84566 17.4386 3.60598 16.9681C3.3335 16.4334 3.3335 15.7333 3.3335 14.3332V5.6665C3.3335 4.26637 3.3335 3.56631 3.60598 3.03153C3.84566 2.56112 4.22811 2.17867 4.69852 1.93899C5.2333 1.6665 5.93336 1.6665 7.3335 1.6665H10.01C10.6215 1.6665 10.9272 1.6665 11.2149 1.73558C11.47 1.79682 11.7139 1.89783 11.9375 2.0349C12.1898 2.18951 12.406 2.4057 12.8384 2.83808L15.4953 5.49493C15.9276 5.92731 16.1438 6.1435 16.2984 6.39579C16.4355 6.61947 16.5365 6.86333 16.5978 7.11842C16.6668 7.40614 16.6668 7.71188 16.6668 8.32336Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewContractIcon);
export default __webpack_public_path__ + "static/media/new_contract_icon.9513a11a91af404f1e3eb15daada2eff.svg";
export { ForwardRef as ReactComponent };